import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const FileIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M15.0173 2.15625C15.161 2.15586 15.3034 2.18397 15.4362 2.23897C15.5689 2.29396 15.6895 2.37475 15.7908 2.47664L20.0156 6.70148C20.1175 6.80282 20.1983 6.92336 20.2533 7.05612C20.3083 7.18887 20.3364 7.33122 20.336 7.47492V20.7499C20.336 21.3532 19.8403 21.8438 19.2312 21.8438H4.76109C4.15172 21.8438 3.65625 21.3532 3.65625 20.7499V3.25008C3.65625 2.6468 4.15195 2.15625 4.76109 2.15625H15.0173ZM15.0173 1.5H4.76109C3.78844 1.5 3 2.28352 3 3.25008V20.7499C3 21.7165 3.78844 22.5 4.76109 22.5H19.2312C20.2038 22.5 20.9923 21.7165 20.9923 20.7499V7.47492C20.9922 7.01078 20.8078 6.56566 20.4797 6.23742L16.2548 2.01258C15.9266 1.68444 15.4815 1.50007 15.0173 1.5Z"
        fill="currentColor"
      />
      <path
        d="M15 1.5V5.50008C15.0001 6.03047 15.2108 6.53912 15.5858 6.91417C15.9609 7.28921 16.4695 7.49994 16.9999 7.5H21L15 1.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(FileIcon);
